
import { defineComponent, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import objectPath from "object-path";
import { useRouter } from "vue-router";

interface RoleRequest {
  status: number;
}

export default defineComponent({
  setup() {
    const store = useStore();
    const router = useRouter();
    const roles = computed(() => {
      return store.getters.getRolesData;
    });
    const op = computed(() => objectPath);
    const user = computed(() => store.getters.getUser);
    const isAnyRoleSelected = computed(() => {
      return user.value?.userRoles?.length ?? false
    })
    const isRoleAttached = (id) => {
      const roleRequest: RoleRequest = objectPath
        .get(user.value, "userRoleRequests", [])
        .find((roleRequest) => {
          return objectPath.get(roleRequest, "role.id") == id;
        })!;
      return roleRequest?.status;
    };
    const createRole = async (id) => {
      try {
        const response = await store.dispatch(Actions.ATTACH_ROLE, {
          id: id,
        });
        if (response !== true) throw new Error();
        await store.dispatch(Actions.AUTH_USER);

        store.commit("setAlert", {
          message: "Success",
          subMessage: "Role is pending for approval",
          variant: "primary",
          duration: 4000,
          show: true,
        });
      } catch (err) {
        const error = store.getters.getErrors;
        store.commit("setAlert", {
          message: "Error",
          subMessage: error,
          variant: "danger",
          duration: 4000,
          show: true,
        });
      }
    };
    const attachRole = async (id) => {
      let roleNameIdKeyValues = {};
      for (let i = 0; i < roles.value.length; i++) {
        roleNameIdKeyValues[roles.value[i].id] = roles.value[i].name;
      }
      if (roleNameIdKeyValues[id].toLowerCase() === "founder") {
        if (user.value.founder) {
          return createRole(id);
        }
        router.push("/create-investment-opportunity");
      } else if (roleNameIdKeyValues[id].toLowerCase() === "expert") {
        if (!(user.value.expert instanceof Array)) {
          return createRole(id);
        }
        router.push("/expert-profile");
      } else if (roleNameIdKeyValues[id].toLowerCase() === "investor") {
        if (!(user.value.investor instanceof Array)) {
          return createRole(id);
        }
        router.push("/investor-profile");
      }
    };
    onMounted(async () => {
      try {
        if (!roles.value.length) {
          const response = await store.dispatch(Actions.GET_ROLES);
          if (response !== true) throw new Error();
        }
      } catch (err) {
        console.log("error in fetching roles");
      }
    });
    return {
      isAnyRoleSelected,
      isRoleAttached,
      user,
      roles,
      op,
      attachRole,
    };
  },
});
